<template>
  <v-container class="view my-4">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6">
        <v-img
          lazy-src="./../assets/illustration/404.svg"
          src="./../assets/illustration/404.svg"
          contain
          block
        ></v-img>
      </v-col>
      <v-col cols="12" sm="4" class="justify-center text-center">
        <h2 class="display-5 text-center">Page Not Found</h2>

        <p class="sub-hero-text my-4">
          It looks like someone has run off with that page While we send out a
          search party why don&apos;t you go back to home page and retry
        </p>
        <v-btn
          color="var(--purple)"
          class="ma-2 white--text text-center"
          elevation="3"
          large
          to="/"
        >
          Back to home
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
};
</script>

<style scoped>
img {
  max-width: 100%;
  min-width: 45%;
}
</style>

